// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3fbb07b2","453":"4297e0f3","455":"7f2d21f9","977":"fa91bca9"}[chunkId] + ".chunk.js";
};